module.exports = __webpack_public_path__ + "images/mdj/members/message/outboxdetail/outboxdetail_icon01-959c7ef2e0544e5c1e52df4c3ce95243.png";